import { isEmpty } from 'lodash/fp';

import { CmsInsuranceTypeContent } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';

type Props = {
  cmsSectionContent?: CmsInsuranceTypeContent['promotions'] | null;
};

const mapPromotions = ({ cmsSectionContent }: Props) => {
  const promotions = cmsSectionContent;
  return isEmpty(promotions) ? null : { promotions, type: CONTENT_SECTIONS.PROMOTIONS };
};

export default mapPromotions;
